"use client"

import React from "react"
import { BADGE_GROUPS, getTextColorForBg as getTextColor } from "../utils/badgeColors"

const BadgeColorTable: React.FC = () => {
  // Detectar si hay datos en las columnas opcionales
  const hasCaras = BADGE_GROUPS.some(group => group.caras !== undefined)
  const hasBoletos = BADGE_GROUPS.some(group => group.boletos !== undefined)

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="bg-gray-100 text-gray-600 uppercase tracking-wide">
            <th className="px-3 py-2 text-left border border-gray-200">Color de Gafete</th>
            <th className="px-3 py-2 text-left border border-gray-200">Tipo de Gafete</th>
            <th className="px-3 py-2 text-center border border-gray-200">Tipo</th>
            {hasCaras && (
              <th className="px-3 py-2 text-center border border-gray-200">Caras</th>
            )}
            {hasBoletos && (
              <th className="px-3 py-2 text-center border border-gray-200">Boletos Rifa</th>
            )}
          </tr>
        </thead>
        <tbody>
          {BADGE_GROUPS.map((group, groupIndex) =>
            group.types.map((type, typeIndex) => (
              <tr
                key={`${group.color}-${typeIndex}`}
                className={groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 align-middle"
                  >
                    <div className="flex items-center gap-2">
                      <span
                        className="inline-flex items-center justify-center px-2 py-1 rounded-lg text-xs font-mono font-semibold shadow-sm whitespace-nowrap"
                        style={{
                          backgroundColor: group.color,
                          color: getTextColor(group.color),
                        }}
                        title={group.label}
                      >
                        {group.color.toUpperCase()}
                      </span>
                      <span className="text-gray-600 font-medium">{group.label}</span>
                    </div>
                  </td>
                )}
                <td className="px-3 py-2 border border-gray-200 text-gray-800">{type}</td>
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center text-gray-600 align-middle"
                  >
                    {group.label}
                  </td>
                )}
                {hasCaras && typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center font-medium text-gray-800 align-middle"
                  >
                    {group.caras}
                  </td>
                )}
                {hasBoletos && typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center text-gray-600 align-middle"
                  >
                    {group.boletos}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

export default BadgeColorTable
